import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Google
 * id 4277434D-74AD-48E7-9C5F-BB7226C4FC39
 * name trending-up
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/trending-up.svg
 * tags
 */
export const TrendingUpIcon = createSvgIcon(<><path d="M16,6L18.29,8.29L13.41,13.17L9.41,9.17L2,16.59L3.41,18L9.41,12L13.41,16L19.71,9.71L22,12V6H16Z" /></>, 'TrendingUpIcon');
export default TrendingUpIcon